import styles from "./SuperAdmin.module.css";
import { useSuperAdmin } from "./useSuperAdmin";
import theme from '../../themes/ThemeLoader';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function SuperAdmin() {
    const { username, setUsername, password, setPassword, handleAccess, showPassword, setShowPassword } = useSuperAdmin();
    return (
        <div className={styles.superAdminContainer} style={{ backgroundImage: `url(${theme.homeBackgroundImage})` }}>
            <div className={styles.card}>
                <img src={theme.logo} alt="Logo" />
                <h2 style={{ color: theme.homeWelcomeMessageColor }}>Painel de criação de clientes </h2>
                <form onSubmit={handleAccess}>
                <label style={{ color: theme.homeLabelColor }} htmlFor="login">Login</label>
                <input
                    id="login"
                    style={{ backgroundColor: theme.homeBackgroundColorInput }}
                    required
                    type="text"
                    placeholder="Digite seu login"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <label style={{ color: theme.homeLabelColor }} htmlFor="password">Senha</label>
                <div className={styles.passwordFieldWrapper}>
                    <input
                        id="password"
                        style={{ backgroundColor: theme.homeBackgroundColorInput }}
                        required
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Digite sua senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        type="button"
                        className={styles.passwordToggleButton}
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ color: theme.homeLabelColor }}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>
                <button type="submit" className={styles.submitButton} style={{ backgroundColor: theme.homeBackgroundColorButton }}>Entrar</button>
                </form>
            </div>
        </div>
    );
}

export default SuperAdmin;